export default "__VITE_ASSET__BIYM7nJ9__"